module.exports = __webpack_public_path__ + "static/christina-yacht-7-ebb8a290e2c5d01ac13ed543c751a3b1.jpg";